import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { OeAppService } from './oe-app.service';

declare var window: any;

@Injectable()
export class WindowService {
  lastWindowOpened;

  constructor(private oeAppService: OeAppService) {
    this._overrideWindowOpen();
  }

  nativeWindow(): any {
    return window;
  }
  getWindowHeight() {
    return window.innerHeight;
  }
  get isToolbarEnabled(): boolean {
    return window.isToolbarEnabled || false;
  }
  getDomain() {
    const { location } = window;
    return `${location.protocol}//${location.host}`;
  }
  getLocationHrefWithoutQueries() {
    return window.location.href.split('?')[0];
  }
  redirectToUrl(url) {
    window.location = url;
  }
  redirectToHref(href: string) {
    window.location.href = href;
  }
  openUrl(url) {
    window.open(url);
  }
  getSearchParams() {
    return new URLSearchParams(window.location.search.substr(1));
  }
  getNewFileReader() {
    return new FileReader();
  }
  _overrideWindowOpen() {
    const pipe = (f, g) => (...args) => g(f(...args));
    const recordWindowOpen = (w) => (this.lastWindowOpened = w);
    window.open = pipe(window.open, recordWindowOpen);
  }
  getLastOpenedWindow() {
    return this.lastWindowOpened;
  }

  getHref() {
    return window.location.href;
  }

  getPathName() {
    return window.location.pathname;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/window.service.ts